"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classNames = require("classnames");

function modsClassName(props) {
  var modKeys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    modKeys[_i - 1] = arguments[_i];
  }

  var classes = props.classes;
  return classNames.apply(void 0, modKeys.map(function (key) {
    var _a;

    return _a = {}, _a[classes[key]] = props[key], _a;
  }));
}

exports.modsClassName = modsClassName;